import { z } from "zod";
import { isoDateSchema, objectIdSchema } from "./common";
export const auditActionEnum = z.enum([
    "user.login",
    "user.logout",
    "user.register",
    "user.password_reset",
    "device.paired",
    "device.removed",
    "api_key.created",
    "api_key.revoked",
    "webhook.created",
    "webhook.deleted",
    "admin.plan_override",
    "admin.impersonate",
    "admin.kill_switch",
]);
export const auditLogSchema = z.object({
    _id: objectIdSchema,
    userId: objectIdSchema,
    actorId: objectIdSchema,
    action: auditActionEnum,
    targetType: z.string().min(1).max(60),
    targetId: z.string().min(1).max(60),
    ip: z.string().max(64),
    userAgent: z.string().max(300),
    metadata: z.record(z.string(), z.unknown()).default({}),
    createdAt: isoDateSchema,
});
//# sourceMappingURL=audit.js.map